import { RenderListItem } from '../../api/rendersApi';

export type TonightGroup = 'needs_listen' | 'preparing' | 'needs_help';

export function tonightGroupForStatus(status: RenderListItem['status']): TonightGroup | null {
  if (status === 'machine_passed') return 'needs_listen';
  if (status === 'needs_review' || status === 'queued' || status === 'rendering' || status === 'regenerating') return 'preparing';
  if (status === 'failed') return 'needs_help';
  return null;
}

export function groupTonightRenders(renders: RenderListItem[]): Record<TonightGroup, RenderListItem[]> {
  const grouped: Record<TonightGroup, RenderListItem[]> = { needs_listen: [], preparing: [], needs_help: [] };
  renders.forEach((render) => {
    const group = tonightGroupForStatus(render.status);
    if (group) grouped[group].push(render);
  });
  (Object.keys(grouped) as TonightGroup[]).forEach((group) => {
    grouped[group].sort((a, b) => {
      const byDate = b.created_at.localeCompare(a.created_at);
      return byDate || b.render_id.localeCompare(a.render_id);
    });
  });
  return grouped;
}

export function latestApprovedPerStory(renders: RenderListItem[]): RenderListItem[] {
  const latest = new Map<string, RenderListItem>();
  renders.filter((render) => render.status === 'parent_approved').forEach((render) => {
    const previous = latest.get(render.story_id);
    if (!previous
      || render.created_at > previous.created_at
      || (render.created_at === previous.created_at && render.render_id > previous.render_id)) {
      latest.set(render.story_id, render);
    }
  });
  return Array.from(latest.values()).sort((a, b) => {
    const byDate = b.created_at.localeCompare(a.created_at);
    return byDate || b.render_id.localeCompare(a.render_id);
  });
}
